import React, { useMemo, useState, useEffect } from 'react';
import _ from 'lodash';
import {
    makeStyles,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    useTheme,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useSelector } from 'react-redux';
import helpers from 'app/utils/helpers';

import companyEndpoints from 'app/api/services/companyEndpoints';
import daesEndpoint from 'app/api/services/daesEndpoint';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import moment from 'moment';
import { STATUS_COLORS } from 'app/config/status';
import { SERVICES_CODES, SERVICES_GROUPS } from 'app/config/services';

import styles from './styles';
const useStyles = makeStyles(styles);

function Summary() {
    const classes = useStyles();
    const theme = useTheme();

    const [expanded, setExpanded] = useState(false);
    const [company, setCompany] = useState({});
    const [rows, setRows] = useState([]);

    const [pagination, setPagination] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);

    const request = useSelector((state) => state.requests.details);

    const requestJsonData = useMemo(() => {
        if (request.jsonSolicitacao) return JSON.parse(request.jsonSolicitacao);
        return {};
    }, [request]);

    useEffect(() => {
        const init = async () => {
            if (request.cdEmpresa) {
                const response = await companyEndpoints.getCompany({ cdEmpresa: request.cdEmpresa });
                if (response?.status === 200 && response?.data) {
                    setCompany(response.data);
                }
            } else if (
                requestJsonData &&
                Object.keys(requestJsonData).length > 0 &&
                request.cdServico !== SERVICES_CODES.ACESSO_PORTAL_FISICA &&
                request.cdServico !== SERVICES_CODES.ACESSO_PORTAL_JURIDICA
            ) {
                setCompany(requestJsonData);
            }
        };
        init();
    }, [request, requestJsonData]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const onChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const onChangeRowsPerPage = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        setPage(0);
    };

    let columns = [
        { title: 'Nome', field: 'name', align: 'left' },
        { title: 'CPF/CNPJ', field: 'cnpj', align: 'left' },
        { title: 'nº DAE', field: 'num_dae', align: 'left' },
        { title: 'Situação', field: 'situacao', align: 'left' },
        { title: 'Data Pagamento', field: 'dtPagamento', align: 'left' },
    ];

    if (SERVICES_GROUPS.VEHICLES.includes(request.cdServico)) {
        columns = [
            { title: 'Placa', field: 'dePlaca', align: 'left' },
            { title: 'Ranavam', field: 'renavam', align: 'left' },
            { title: 'nº DAE', field: 'num_dae', align: 'left' },
            { title: 'Situação', field: 'situacao', align: 'left' },
            { title: 'Data Pagamento', field: 'dtPagamento', align: 'left' },
        ];
    }

    useEffect(() => {
        const init = async () => {
            const filters = {};
            if (requestJsonData.deCnpjMatriz && requestJsonData.deCnpjMatriz !== '') {
                filters.deCnpjMatriz = requestJsonData.deCnpjMatriz;
            }

            if (request.cdEmpresa && request.cdEmpresa !== '') {
                filters.cdEmpresa = request.cdEmpresa;
            }
            try {
                const response = await daesEndpoint.getDAEs({
                    page: page,
                    size: pageSize,
                    request: {
                        ...filters,
                        cdSolicitacao: request.cdSolicitacao,
                        daesPendentes: false,
                    },
                });
                if (response?.status === 200 && response?.data && response?.data?.content) {
                    setPagination(response.data);
                    const r = response.data.content.map((res) => {
                        const dePlaca = res.dePlaca;
                        let renavam = '';
                        if (requestJsonData?.veiculos) {
                            const v = _.find(requestJsonData.veiculos, ['dePlaca', dePlaca]);
                            if (v) {
                                renavam = v.deRenavam;
                            }
                        }

                        return {
                            name: res.sacado?.deNome,
                            cnpj: `${helpers.formatarDocumento(res.sacado?.nuIdent)}`,
                            dePlaca,
                            renavam,
                            num_dae: `${res.nuGru}/${res.nuAnoGru}`,
                            situacao: res.dtPagamento && res.dtPagamento !== '' ? 'Pago' : 'Aguardando Pagamento',
                            dtPagamento:
                                res.dtPagamento && res.dtPagamento !== ''
                                    ? moment.utc(res.dtPagamento).format('DD/MM/YYYY')
                                    : '-',
                        };
                    });
                    setRows(r);
                }
            } catch (error) {}
        };
        init();
    }, [page, pageSize, request, requestJsonData, requestJsonData.deCnpjMatriz]);

    return (
        <Paper>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Accordion
                        elevation={0}
                        square
                        expanded={expanded === 'summary'}
                        onChange={handleChange('summary')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="summarybh-content"
                            id="summarybh-header">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TableContainer>
                                        <Table className={classes.tableInitialSummary} aria-label="simple table">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align="left" className={classes.borderNone}>
                                                        <h4 className={classes.summaryTitle}>Data solicitação</h4>
                                                        <h3 className={classes.summarySubtitle}>
                                                            {request.dtCadastro
                                                                ? helpers.formatarData(request.dtCadastro, true)
                                                                : '-'}
                                                        </h3>
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.borderNone}>
                                                        <h4 className={classes.summaryTitle}>Solicitação</h4>
                                                        <h3 className={classes.summarySubtitle}>
                                                            {request.nuSolicitacaoFmt ? request.nuSolicitacaoFmt : '-'}
                                                        </h3>
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.borderNone}>
                                                        <h4 className={classes.summaryTitle}>Processo</h4>
                                                        <h3 className={classes.summarySubtitle}>
                                                            {request.nuProcesso ? request.nuProcesso : '-'}
                                                        </h3>
                                                    </TableCell>
                                                    {company && company?.cdCertificado && (
                                                        <TableCell align="left" className={classes.borderNone}>
                                                            <h4 className={classes.summaryTitle}>Empresa</h4>
                                                            <h3 className={classes.summarySubtitle}>
                                                                {company.cdEmpresa
                                                                    ? `cod. ${company.cdEmpresa} - `
                                                                    : ''}
                                                                {company.cdTipoPessoaFisica
                                                                    ? company.nmCompleto || ''
                                                                    : company.deRazaoSocial || ''}
                                                            </h3>
                                                        </TableCell>
                                                    )}
                                                    {(!company || Object.keys(company).length === 0) &&
                                                        request.cdUsuarioSolicitacao && (
                                                            <TableCell align="left" className={classes.borderNone}>
                                                                <h4 className={classes.summaryTitle}>
                                                                    Usuário solicitante
                                                                </h4>
                                                                <h3 className={classes.summarySubtitle}>
                                                                    {request.cdUsuarioSolicitacao
                                                                        ? request.cdUsuarioSolicitacao
                                                                        : ''}
                                                                </h3>
                                                            </TableCell>
                                                        )}
                                                    <TableCell align="left" className={classes.borderNone}>
                                                        <h4 className={classes.summaryTitle}>Serviço</h4>
                                                        <h3 className={classes.summarySubtitle}>
                                                            {request.servico?.nmServico
                                                                ? request.servico?.nmServico
                                                                : ''}
                                                        </h3>
                                                        <h5
                                                            className={classes.summaryInfoSubtitle}
                                                            style={{
                                                                color: `${STATUS_COLORS[request.situacao?.cdSituacao]?.color}`,
                                                            }}>
                                                            {request.situacao?.deSituacao}
                                                        </h5>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        {company && Object.keys(company).length > 0 && (
                            <AccordionDetails>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <h4 className={classes.summaryTitle}>Nome / Razão Social</h4>
                                        <h3 className={classes.summarySubtitle}>
                                            {company.nmCompleto || company.deRazaoSocial || company.nmUsuario || '-'}
                                        </h3>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <h4 className={classes.summaryTitle}>CPF/CNPJ</h4>
                                        <h3 className={classes.summarySubtitle}>
                                            {helpers.formatarDocumento(
                                                company.deCpf || company.deCpfCnpj || company.deCnpjMatriz,
                                            ) || '-'}
                                        </h3>
                                    </Grid>
                                    {company.tipoEmpresa && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <h4 className={classes.summaryTitle}>Tipo de empresa</h4>
                                            <h3 className={classes.summarySubtitle}>
                                                {company.tipoEmpresa?.deTipoEmpresa
                                                    ? company.tipoEmpresa?.deTipoEmpresa
                                                    : ''}
                                            </h3>
                                        </Grid>
                                    )}
                                    {company.ramoAtividade && (
                                        <Grid item xs={12} sm={6} md={4}>
                                            <h4 className={classes.summaryTitle}>Ramo de atividade</h4>
                                            <h3 className={classes.summarySubtitle}>
                                                {company.ramoAtividade?.deRamoAtividade
                                                    ? company.ramoAtividade?.deRamoAtividade
                                                    : ''}
                                            </h3>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={6} md={4}>
                                        <h4 className={classes.summaryTitle}>Solicitante</h4>
                                        <h3 className={classes.summarySubtitle}>
                                            {request.cdUsuarioSolicitacao ? request.cdUsuarioSolicitacao : ''}
                                        </h3>
                                    </Grid>
                                    {rows.length > 0 && (
                                        <Grid item xs={12}>
                                            <CustomPaginationActionsTable
                                                columns={columns}
                                                rows={rows}
                                                hideFilterOrder={true}
                                                hideItemOrder={true}
                                                placeholderSearch="Busca"
                                                pagination={pagination}
                                                onChangePage={onChangePage}
                                                onChangeRowsPerPage={onChangeRowsPerPage}
                                                onBlurSearch={() => {}}
                                                onClickOrder={() => {}}
                                                onChangeSearch={() => {}}
                                                onClickRow={() => {}}
                                                onChangeInitialDate={() => {}}
                                                onChangeFinalDate={() => {}}
                                                backgroundHeadColor={theme.palette.primary.main}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </AccordionDetails>
                        )}
                    </Accordion>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Summary;
